import { Snackbar } from '@mui/material';
import Slide, { SlideProps } from '@mui/material/Slide';
import { styled } from '@mui/material/styles';
import React from 'react';
import zeplinColor from '../../../theme/Color';

type CustomAlertProp = {
  open: boolean;
  message: React.ReactNode;
  handleClose: () => void;
  error?: boolean;
};

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction='up' />;
}

const CustomBar = styled(Snackbar)<{ error?: string }>(({ theme, error }) => ({
  '& .MuiPaper-root.MuiPaper-elevation': {
    borderRadius: 14,
    backgroundColor: error === 'true' ? zeplinColor.Error : zeplinColor.BasicBlack,

    minWidth: '162px',
    minHeight: 56,
    padding: '12px 24px',
  },
  '& .MuiSnackbarContent-message': {
    padding: 0,
  },
}));

const CustomAlert = ({ open, message, handleClose, error = false }: CustomAlertProp) => {
  return (
    <CustomBar
      open={open}
      slots={{ transition: SlideTransition }}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      message={message}
      onClose={handleClose}
      error={error ? 'true' : 'false'}
    />
  );
};

export default CustomAlert;
